import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarState {
  isExpanded: boolean;
  toggle: () => void;
}

const SIDEBAR_STATE_KEY = "supervizor_sidebar_expanded";

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isExpanded: true,
      toggle: () => set((state) => ({ isExpanded: !state.isExpanded })),
    }),
    {
      name: SIDEBAR_STATE_KEY,
      partialize: (state) => ({
        isExpanded: state.isExpanded,
      }),
    },
  ),
);
